import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Info } from 'lucide-react';

interface BulkRemoveFromStructureDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  onConfirm: () => void;
}

export function BulkRemoveFromStructureDialog({
  open,
  onOpenChange,
  count,
  onConfirm,
}: BulkRemoveFromStructureDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <Info className="h-5 w-5 text-info-600" />
            <AlertDialogTitle>Remove from Hierarchy?</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-3 pt-2">
            <p className="font-medium text-foreground">
              Remove {count} cost centre{count !== 1 ? 's' : ''} from the hierarchy?
            </p>
            <p>
              {count !== 1 ? 'These cost centres' : 'This cost centre'} will be removed from the
              hierarchy but will remain in the project. They will be available in 'Add Existing' to
              re-add later.
            </p>
            <p>
              All data (budget, actuals, custom fields) will be preserved.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-primary hover:bg-primary/90"
          >
            Remove from Hierarchy
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
